import { StandardOperatingProcedureQueryResult } from '@/graphql/generated/hooks'

export const POLL_INTERVAL = 5000
export type SOPType =
  StandardOperatingProcedureQueryResult['data']['standardOperatingProcedure']
